module.exports = __webpack_public_path__ + "images/oth-career-tracks.jpg";